import apiClient from './api';

export type OrganizationType = 'system' | 'distributor' | 'vendor';
export type Role =
  | 'system_super_admin'
  | 'system_ops_admin'
  | 'distributor_admin'
  | 'distributor_viewer'
  | 'vendor_operator'
  | 'vendor_viewer';

export interface SessionUser {
  role: Role;
  organizationType: OrganizationType;
  commonName: string;
  displayName: string | null;
  vendorIdx: string | null;
  distributorIdx: string | null;
  canSelfManageUnits: boolean;
  sudoActive: boolean;
  sudoUntil: string | null;
  expiresAt: string;
}

export interface LoginResult {
  role: Role;
  organizationType: OrganizationType;
  commonName: string;
  displayName: string | null;
  redirectTo: string;
  expiresAt: string;
}

/**
 * P12 登入
 */
export async function p12Login(file: File, password: string): Promise<LoginResult> {
  const resp = await apiClient.uploadCertificate<LoginResult>('/auth/p12-login', file, password);
  const data = (resp as any).data ?? resp;
  return data as LoginResult;
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function getSession(): Promise<SessionUser | null> {
  try {
    const resp = await apiClient.get<SessionUser>('/auth/session-me');
    return ((resp as any).data ?? resp) as SessionUser;
  } catch (err: any) {
    if (err?.response?.status === 401) return null;
    throw err;
  }
}

export async function grantSudo(password: string): Promise<{ sudoUntil: string }> {
  const resp = await apiClient.post<{ sudoUntil: string }>('/auth/sudo', { password });
  return ((resp as any).data ?? resp) as { sudoUntil: string };
}

export function roleHomePath(role: Role): string {
  if (role.startsWith('system_')) return '/admin';
  if (role.startsWith('distributor_')) return '/distributor';
  if (role.startsWith('vendor_')) return '/vendor';
  return '/';
}
